import {FormProductPlan} from "../../api/types/productPlan";
import * as yup from "yup";

export const initialValues: FormProductPlan = {
    productPlan: {
        commercialCategory: null,
        commercialSegment: null,
        productCode: null,
        locationGroup: null,
        ratePlan: {
            rate: null,
            carGroup: null,
            rentalPeriod: null,
            price: null,
            extraKm: null
        },
        exceptionPlan: {
            newCombination: {
                name: null,
                from: null,
                to: null
            },
            viewCombination: {
                name: null,
                from: null,
                to: null,
                exception: []
            },
            newException: {
                ancillary: null,
                exceptionName: null
            }
        },
        excessPlan: {
            name: null,
            from: null,
            to: null,
            carGroup: ""
        }
    },

};

export const validationSchema = ({t}: { t: Function }) => yup.object().shape({
    productPlan: yup.object().shape({
        commercialCategory: yup.object().shape({
            code: yup.string(),
            label: yup.string()
        }).nullable().required(t("translation:validation.fieldMandatory")),
        commercialSegment: yup.object().shape({
            code: yup.string(),
            label: yup.string()
        }).nullable().required(t("translation:validation.fieldMandatory")),
        productCode: yup.object().shape({
            code: yup.string(),
            label: yup.string()
        }).nullable().required(t("translation:validation.fieldMandatory")),
        locationGroup: yup.object().shape({
            code: yup.string(),
            label: yup.string()
        }).nullable().required(t("translation:validation.fieldMandatory")),
        exceptionPlan: yup.object().shape({
            newException: yup.object().shape({
                ancillary: yup.object().shape({
                    code: yup.string(),
                    label: yup.string()
                }).nullable().required(t("translation:validation.fieldMandatory")),
                exceptionName: yup
                    .string()
                    .nullable()
                    .required(t("translation:validation.fieldMandatory")),
            })
        })
    })
}).defined();